import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ObligationsList from './ObligationsList';

//redux
import { ToastContainer } from 'react-toastify';

const Obligations = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '/normative/list', label: 'Normativa', icon: 'icon-book-minus' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Obligaciones' links={breadcrumbLinks} icon={'icon-landmark'}/>
					<ObligationsList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Obligations;
